export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
  }).format(amount);
};

export const formatCurrencyNoDecimals = (amount: number) => {
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatCompactCurrency = (amount: number): string => {
  const absAmount = Math.abs(amount);
  const sign = amount < 0 ? "-" : "";
  
  if (absAmount >= 1_000_000) {
    // Millones: $1M, $2.5M
    const millions = absAmount / 1_000_000;
    const formatted = millions % 1 === 0 ? millions.toString() : millions.toFixed(1);
    return `${sign}$${formatted}M`;
  } else if (absAmount >= 1_000) {
    // Miles: $100k, $250k
    const thousands = absAmount / 1_000;
    const formatted = thousands % 1 === 0 ? thousands.toString() : thousands.toFixed(1);
    return `${sign}$${thousands}k`;
  } else {
    // Valores pequeños sin decimales
    return `${sign}$${Math.round(absAmount)}`;
  }
};
